import Staff, { OrganizationStaff } from '../../model/Staff';

export interface StaffState {
    staff: Array<Staff>;
    organizationStaff: Array<OrganizationStaff>;
    member?: Staff;
    status: StaffStatus;
    loading: boolean;
    savedStaff?: Staff;
    warnings: Array<string>;
}

export enum StaffStatus {
    Initial,
    Fetching,
    FetchSuccess,
    OrganizationStaffFetching,
    OrganizationStaffFetchSuccess,
    Getting,
    GetSuccess,
    GettingByEmail,
    GetByEmailSuccess,
    GetByEmailNotFound,
    Saving,
    SaveSuccess,
    SavingDefaultSchedule,
    SaveDefaultScheduleSuccess,
    Deleting,
    DeleteSuccess,
    Activating,
    Deactivating,
    ActivateSuccess,
    DeactivateSuccess,
    Error
}
